import { createContext } from "react";

import { EpisodeDetails, TvSeasonDetails, TvSeriesDetails } from "../../../TvSeriesDetails";
import { UpdatedSeasonData } from "../info/edit-season-form/EditSeasonForm";

interface ISeasonPageContext {
    selectedTvSeries: TvSeriesDetails;
    selectedSeason: TvSeasonDetails;
    addEpisode(newEpisode: EpisodeDetails): void;
    updateSeason(updatedSeasonData: UpdatedSeasonData): void;
}

const defaultSeasonPageContext: ISeasonPageContext = {} as ISeasonPageContext;

export const SeasonPageContext = createContext<ISeasonPageContext>(defaultSeasonPageContext);
